<template>
    <footer class="pagefooter">
        <FooterMusicBuiz />
        <FooterMenu />
    </footer>
</template>

<script>
import FooterMusicBuiz from '@/components/nav/FooterMusicBuiz.vue';
import FooterMenu from '@/components/nav/FooterMenu.vue';

    export default {
        name:'BodyFooter',
        components:{
            FooterMusicBuiz,
            FooterMenu
        }
    }
</script>